import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
margin-left: 6px;
width: 12px;
height: 12px;
`;

type Props = {
  color: string
} | typeof defaultProps;

const defaultProps = {
  color: 'rgb(126, 126, 126)',
};

const OpenInNewTab = function OpenInNewTab(props: Props) {
  const { color } = props;
  return (
    <SVG width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="open-in-new-tab">
      <path d="M5.19858 1C4.98176 1 4.80593 1.17579 4.80593 1.39265C4.80593 1.6095 4.98176 1.7853 5.19858 1.7853H7.65955L4.40334 5.04151C4.24999 5.19484 4.24999 5.44347 4.40334 5.5968C4.55667 5.75013 4.80529 5.75013 4.95862 5.5968L8.21483 2.34059V4.80152C8.21483 5.01838 8.39062 5.19416 8.60748 5.19416C8.82434 5.19416 9.00013 5.01838 9.00013 4.80153V1.39265C9.00013 1.1758 8.82434 1 8.60748 1H5.19858Z" fill={color} stroke={color} strokeWidth="0.2" />
      <path d="M1.14704 2.5706C1.14704 2.28146 1.38144 2.04707 1.67058 2.04707H2.89214C3.18129 2.04707 3.41567 1.81267 3.41567 1.52353C3.41567 1.2344 3.18129 1 2.89214 1H1.67058C0.80316 1 0.0999756 1.70318 0.0999756 2.5706V8.32947C0.0999756 9.19692 0.80316 9.90007 1.67058 9.90007H7.42945C8.29689 9.90007 9.00005 9.19692 9.00005 8.32947V7.41952C9.00005 7.13037 8.76566 6.89598 8.47652 6.89598C8.18737 6.89598 7.95298 7.13037 7.95298 7.41952V8.32947C7.95298 8.61862 7.7186 8.85301 7.42945 8.85301H1.67058C1.38144 8.85301 1.14704 8.61862 1.14704 8.32947V2.5706Z" fill={color} />
    </SVG>
  );
};
OpenInNewTab.defaultProps = defaultProps;
export default OpenInNewTab;
